import { CustomFlowbiteTheme } from 'flowbite-react';

export const avatarTheme: CustomFlowbiteTheme['avatar'] = {
    root: {
        initials: {
            text: 'text-system-on-surface dark:text-white',
            base: 'inline-flex relative overflow-hidden justify-center items-center bg-system-surface-container dark:bg-system-surface-primary',
        },
        img: {
            off: 'relative overflow-hidden bg-system-on-priamry dark:bg-catapult-black',
        },
        rounded: 'rounded-full ring-white',
        color: {
            light: 'ring-white dark:catapult-black',
        },
        stacked: 'ring-2 ring-white dark:catapult-black',
        status: {
            base: 'absolute h-3.5 w-3.5 rounded-full border-2 border-white',
        },
    },
    groupCounter: {
        base:
            'relative flex items-center justify-center w-10 h-10 text-xs' +
            ' font-medium text-white bg-catapult-grey-900 rounded-full ring-2 ring-white' +
            ' hover:bg-gray-600 dark:catapult-black',
    },
};
